import {
  createFileRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { requireAuth } from "@/shared/lib/auth-guard";
import { AppLayout } from "@/shared/layouts/app-layout";

export const Route = createFileRoute("/_protected")({
  beforeLoad: requireAuth,
  component: ProtectedLayout,
});

function ProtectedLayout() {
  // 현재 매치된 라우트들에서 layoutMode 컨텍스트 확인
  const matches = useRouterState({ select: (s) => s.matches });
  const hasAgentLayout = matches.some(
    (m) =>
      (m.context as unknown as Record<string, unknown>)?.["layoutMode"] ===
      "agent-first",
  );

  // chat 라우트는 ChatPage 자체에서 AgentLayout을 렌더하므로
  // _protected 레벨에서는 Outlet만 반환 (AppLayout 미적용)
  if (hasAgentLayout) {
    return <Outlet />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
